import { db } from 'config/firebase.js';
import { useEffect, useState } from 'react';
import { collection, query, getDocs } from 'firebase/firestore';

// In-memory only. The fuzzy collection is ~40k docs (~10–20 MB JSON), which
// exceeds the ~5 MB localStorage quota and was silently corrupting the cached
// blob — leaving search empty until manual cache clear. Fetch once per mount,
// hold in React state, no persistence.
function useFuzzyProducts() {
    const [fuzzyProducts, setFuzzyProducts] = useState([]);
    const [fuzzyLoading, setFuzzyLoading] = useState(true);
    const [fuzzyError, setFuzzyError] = useState(false);

    useEffect(() => {
        // Best-effort cleanup of legacy cache entries from prior versions of
        // this hook — frees ~5 MB of stale localStorage on first run.
        try {
            localStorage.removeItem('fuzzyProducts');
            localStorage.removeItem('fuzzyExpiration');
        } catch (_) {}

        let cancelled = false;

        const load = async () => {
            try {
                const fuzzQuery = query(collection(db, 'fuzzySearch', 'topicz', 'fuzzyChoices'));
                const snapshot = await getDocs(fuzzQuery);
                if (cancelled) return;
                const products = snapshot.docs.map(d => ({ ...d.data() }));
                setFuzzyProducts(products);
            } catch (error) {
                console.error('useFuzzyProducts: fetch failed', error);
                if (!cancelled) setFuzzyError(error);
            } finally {
                if (!cancelled) setFuzzyLoading(false);
            }
        };

        load();

        return () => { cancelled = true; };
    }, []);

    return [fuzzyProducts, fuzzyLoading, fuzzyError];
}

export default useFuzzyProducts;